export default function Notifications({
  notifications,
  hasMore,
  loading,
  onLoadMore,
}) {
  return (
    <div className="absolute right-0 mt-3 w-60 bg-white shadow-lg rounded-md max-h-[400px] overflow-y-auto scrollbar-hide">
      <ul className="divide-y">
        {notifications.map((item, index) => (
          <li key={index} className="p-3 text-xs">
            {item.notificationContent}
          </li>
        ))}
      </ul>

      {hasMore && (
        <div className="px-3 pb-3 text-left ">
          <button
            onClick={onLoadMore}
            disabled={loading}
            className="text-[10px] text-blue-600 hover:underline"
          >
            {loading ? "Loading..." : "See more"}
          </button>
        </div>
      )}
    </div>
  );
}